import {Box, Typography} from '@mui/material';
import React from 'react';
import AurTooltip from '../aur-tooltip/AurTooltip';

import {ReactComponent as RightIconDisabled} from '../../../assests/svg/right-icon-disabled.svg';
import {ReactComponent as RightIcon} from '../../../assests/svg/right-icon.svg';
import {ReactComponent as BackIcon} from '../../../../src/assests/svg/back-icon.svg';
import {ReactComponent as BackIconDisabled} from '../../../../src/assests/svg/back-icon-disabled.svg';

import AurButton from '../aur-button/AurButton';
import {t} from 'i18next';
interface INavigationProps {
  totalItems: number;
  currentItem: number;
  onPreviousClick: () => void;
  onNextClick: () => void;
}
const AurPreviousNextNavigation: React.FC<INavigationProps> = (
  props: INavigationProps
) => {
  const {totalItems, currentItem, onPreviousClick, onNextClick} = props;

  const stringPath = 'common.aurPreviousNextNavigation.';

  const hasErrors = totalItems > 0;
  const canGoPrev = currentItem > 1;
  const canGoNext = currentItem < totalItems;
  const popperOffset = {
    popper: {
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 1],
          },
        },
      ],
    },
  };
  return (
    <Box className="pre-next-navigation-container">
      <AurTooltip
        className="typo-text label4_size custom-tooltip-style"
        disableInteractive
        title={
          canGoPrev ? t('common.aurPreviousNextNavigation.previousError') : ''
        }
        slotProps={popperOffset}
      >
        <span>
          <AurButton
            classNames="navigation-btn"
            type="exit"
            size="Small"
            minWidth={32}
            onClick={onPreviousClick}
            disabled={!canGoPrev || !hasErrors}
            dataTestId="previous-button"
            ariaLabel={t(stringPath + 'ariaPrevButton')}
            aria-disabled={!canGoPrev || !hasErrors}
          >
            {!canGoPrev || !hasErrors ? <BackIconDisabled /> : <BackIcon />}
          </AurButton>
        </span>
      </AurTooltip>
      <Typography className="typo-text body4_size" aria-live="polite">
        {hasErrors ? (
          <>
            <span className="error">
              {t('common.aurPreviousNextNavigation.error')}
            </span>{' '}
            <span className="warning">{currentItem}</span>{' '}
            <span className="error">
              {t('common.aurPreviousNextNavigation.of')}
            </span>{' '}
            {totalItems}
          </>
        ) : (
          <span className="error">
            {t('common.aurPreviousNextNavigation.noError')}
          </span>
        )}
      </Typography>
      <AurTooltip
        title={canGoNext ? t('common.aurPreviousNextNavigation.nextError') : ''}
        disableInteractive
        slotProps={popperOffset}
        className="typo-text label4_size custom-tooltip-style"
      >
        <span>
          <AurButton
            classNames="navigation-btn"
            type="exit"
            size="Small"
            minWidth={32}
            onClick={onNextClick}
            disabled={!canGoNext || !hasErrors}
            dataTestId="next-button"
            ariaLabel={t(stringPath + 'ariaNextButton')}
            aria-disabled={!canGoNext || !hasErrors}
          >
            {!canGoNext || !hasErrors ? <RightIconDisabled /> : <RightIcon />}
          </AurButton>
        </span>
      </AurTooltip>
    </Box>
  );
};

export default AurPreviousNextNavigation;
